document.addEventListener('DOMContentLoaded', () => {
  let activeModal = null;

  // ── Helpers ──

  const closeModal = modal => {
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    unlockScroll();
    if (activeModal === modal) activeModal = null;
  };

  const lockScroll = () => {
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = '17px';
  };

  const unlockScroll = () => {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  };

  const getVariants = modal => {
    const raw = modal.getAttribute('data-variants');
    if (!raw) return [];
    try {
      return JSON.parse(raw).filter(v =>
        !v.title.includes('Giftbox') && !v.title.includes('cadeau')
      );
    } catch { return []; }
  };

  const findVariantById = (modal, id) =>
    getVariants(modal).find(v => v.id === Number(id));

  const getProductOptions = modal => {
    const names = [];
    modal.querySelectorAll('.corporate-modal__option .options-item:not([data-band-group])')
      .forEach(g => {
        const label = g.querySelector('.corporate-modal__product-title-label');
        if (label) names.push(label.textContent.trim());
      });
    return names;
  };

  const getActiveBand = modal => {
    const active = modal.querySelector('[data-band-size].active');
    return active ? active.getAttribute('data-band-size') : 'Standaard';
  };

  const findVariantByBandAndColor = (modal, band, colorTitle) => {
    const variants = getVariants(modal);
    const target = band === 'Standaard'
      ? colorTitle.replace(/ Mini$/, '')
      : colorTitle.includes(' Mini') ? colorTitle : colorTitle + ' Mini';
    return variants.find(v => v.options[0] === target) || null;
  };

  const getSelectedOptions = modal => {
    const selected = {};
    modal.querySelectorAll('.swatch.active').forEach(s => {
      const v = findVariantById(modal, s.getAttribute('data-id'));
      if (v) {
        selected[getProductOptions(modal)[0] || 'Color'] = v.options[0];
      }
    });
    modal.querySelectorAll('.o-item.active').forEach(item => {
      const name = item.getAttribute('data-option-name');
      const val = item.getAttribute('data-option-value');
      if (name) selected[name] = val;
    });
    return selected;
  };

  const findVariantByOptions = (modal, selected) => {
    const variants = getVariants(modal);
    if (!variants.length) return null;
    const keys = Object.keys(selected);
    if (!keys.length) return variants[0];
    const opts = getProductOptions(modal);
    return variants.find(v =>
      keys.every(k => {
        const idx = opts.indexOf(k);
        return idx !== -1 && String(v.options[idx]).toLowerCase() === String(selected[k]).toLowerCase();
      })
    ) || null;
  };

  const formatMoney = cents => {
    const abs = Math.abs(cents);
    const sign = cents < 0 ? '-' : '';
    const eur = Math.floor(abs / 100);
    const cent = abs % 100;
    const cStr = cent === 0 ? '' : ',' + (cent < 10 ? '0' : '') + cent;
    return `${sign}${eur}${cStr}€`;
  };

  const updatePrice = (modal, variant, qty) => {
    // 阶梯1（5-10-20）
    const defaultTiers = [{ min: 5, pct: 10 }, { min: 10, pct: 12 }, { min: 20, pct: 14 }];
    // 阶梯2（2-5-10）
    const newTierProducts = ['openrun-pro2-business', 'openrun-business', 'openmove-business', 'openswim-pro-business'];
    const handle = modal.dataset.productHandle;
    const tiers = newTierProducts.includes(handle)
      ? [{ min: 2, pct: 10 }, { min: 5, pct: 15 }, { min: 10, pct: 20 }]
      : defaultTiers;
    let dp = 0;
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (qty >= tiers[i].min) { dp = tiers[i].pct; break; }
    }
    const base = variant.price * qty;
    const unitDiscount = Math.round(variant.price * dp / 100);
    const discountedTotal = (variant.price - unitDiscount) * qty;
    const cur = modal.querySelector('[data-price-current]');
    const orig = modal.querySelector('[data-price-original]');
    if (cur) cur.textContent = formatMoney(discountedTotal);
    if (orig) {
      orig.textContent = formatMoney(base);
      orig.classList.toggle('on-sale', dp > 0);
    }
  };

  const setQuantity = (modal, val) => {
    val = Math.max(1, Math.floor(val));
    const input = modal.querySelector('[data-qty-input]');
    if (input) input.value = val;
    const idInput = modal.querySelector('[data-variant-id]');
    const vid = idInput ? Number(idInput.value) : null;
    const v = vid ? findVariantById(modal, vid) : getVariants(modal)[0];
    if (v) updatePrice(modal, v, val);
    clearQtyError(modal)
  };

  const checkFormValidity = modal => {
    const purpose = modal.querySelector('[name="properties[purpose]"]');
    const company = modal.querySelector('[name="properties[company_name]"]');
    const email = modal.querySelector('[name="properties[company_email]"]');
    const btn = modal.querySelector('[data-add-to-cart]');
    const avail = modal.dataset.variantAvailable !== 'false';
    const valid = avail && purpose.value.trim() && company.value.trim() && email.value.trim();
    btn.classList.toggle('corporate-modal__submit--disabled', !valid);
  };
  const clearQtyError = modal => {
    modal.querySelector('.qty-error')?.remove();
  };
  const selectVariant = (modal, variant) => {
    if (!variant) return;
    const idInput = modal.querySelector('[data-variant-id]');
    if (idInput) idInput.value = variant.id;

    modal.querySelectorAll('.corporate-modal__image img').forEach(img => {
      img.classList.toggle('active', Number(img.getAttribute('data-id')) === variant.id);
    });
    modal.querySelectorAll('[data-variant-stock]').forEach(el => {
      el.classList.toggle('active', Number(el.getAttribute('data-variant-stock')) === variant.id);
    });

    const qty = Number(modal.querySelector('[data-qty-input]')?.value) || 1;
    updatePrice(modal, variant, qty);

    modal.dataset.variantAvailable = String(variant.available);
    const btn = modal.querySelector('[data-add-to-cart]');
    btn.textContent = variant.available ? 'Toevoegen aan winkelwagen' : 'Niet op voorraad';
    checkFormValidity(modal);
    clearQtyError(modal)
  };

  const resetModalState = modal => {
    modal.querySelectorAll(
      '[name="properties[purpose]"], [name="properties[company_name]"], [name="properties[company_email]"]'
    ).forEach(el => { el.value = ''; });

    modal.querySelectorAll('.other-options-content').forEach(group => {
      group.querySelectorAll('.o-item').forEach(el => el.classList.remove('active'));
      const first = group.querySelector('.o-item');
      if (first) first.classList.add('active');
    });

    if (modal.querySelector('[data-band-group]')) {
      modal.querySelectorAll('.product-color-swatch-wrapper .swatch').forEach(s => {
        s.style.display = (s.getAttribute('data') || '').includes('Mini') ? 'none' : '';
      });
    }

    modal.querySelectorAll('.product-color-swatch-wrapper .swatch').forEach(s => s.classList.remove('active'));
    const visible = [...modal.querySelectorAll('.product-color-swatch-wrapper .swatch')]
      .find(s => s.style.display !== 'none');
    const target = visible ? findVariantById(modal, visible.getAttribute('data-id')) : getVariants(modal)[0];

    if (target) selectVariant(modal, target);
    setQuantity(modal, 1);
    if (visible) visible.classList.add('active');
  };
  // ── Event: open modal ──

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-open-modal]');
    if (!btn) return;
    const blockId = btn.getAttribute('data-open-modal');
    const modal = btn.closest('.corporate-products-container')
      ?.querySelector(`[data-modal="${blockId}"]`);
    if (!modal) return;

    if (activeModal && activeModal !== modal) closeModal(activeModal);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
    activeModal = modal;

    resetModalState(modal); 
  });

  // ── Event: close / escape ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-close-modal]');
    if (btn) closeModal(btn.closest('.corporate-modal'));
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && activeModal) closeModal(activeModal);
  });

  // ── Event: view more ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-view-more]');
    if (!btn) return;
    const container = btn.closest('.corporate-products-container');
    if (!container) return;
    const isExpanded = container.classList.toggle('show-all');
    btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
  });

  // ── Event: swatch click ──
  document.addEventListener('click', e => {
    const swatch = e.target.closest('.swatch[data-id]');
    if (!swatch) return;
    const modal = swatch.closest('.corporate-modal');
    if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;

    if (modal.querySelector('[data-band-group]')) {
      const v = findVariantByBandAndColor(modal, getActiveBand(modal), swatch.getAttribute('data'));
      if (v) selectVariant(modal, v);
    } else {
      const v = findVariantById(modal, swatch.getAttribute('data-id'));
      if (v) selectVariant(modal, v);
    }

    swatch.closest('.product-color-swatch-wrapper')
      .querySelectorAll('.swatch')
      .forEach(s => s.classList.remove('active'));
    swatch.classList.add('active');
  });

  // ── Event: option text click (non-band) ──
  document.addEventListener('click', e => {
    const item = e.target.closest('.o-item:not([data-band-size])');
    if (!item) return;
    const modal = item.closest('.corporate-modal');
    if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;
    item.parentElement.querySelectorAll('.o-item').forEach(el => el.classList.remove('active'));
    item.classList.add('active');
    const v = findVariantByOptions(modal, getSelectedOptions(modal));
    if (v) selectVariant(modal, v);
  });

  // ── Event: band toggle ──
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-band-size]');
    if (!btn) return;
    const modal = btn.closest('.corporate-modal');
    if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;

    btn.parentElement.querySelectorAll('[data-band-size]').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    const isMini = btn.getAttribute('data-band-size') === 'Mini';
    const swatches = modal.querySelectorAll('.product-color-swatch-wrapper .swatch');
    swatches.forEach(s => {
      s.style.display = ((s.getAttribute('data') || '').includes('Mini') === isMini) ? '' : 'none';
    });

    const first = [...swatches].find(s => s.style.display !== 'none');
    if (first) {
      const v = findVariantById(modal, first.getAttribute('data-id'));
      if (v) {
        selectVariant(modal, v);
        swatches.forEach(s => s.classList.remove('active'));
        first.classList.add('active');
      }
    }
  });

  // ── Event: qty buttons ──
  document.addEventListener('click', e => {
    const modal = e.target.closest('.corporate-modal');
    if (!modal) return;
    const input = modal.querySelector('[data-qty-input]');
    const val = Number(input?.value) || 1;

    if (e.target.closest('[data-qty-minus]') && val > 1) setQuantity(modal, val - 1);
    if (e.target.closest('[data-qty-plus]')) setQuantity(modal, val + 1);
  });

  // ── Event: qty manual input ──
  document.addEventListener('input', e => {
    const input = e.target.closest('[data-qty-input]');
    if (!input) return;
    const modal = input.closest('.corporate-modal');
    if (!modal) return;
    let val = Number(input.value);
    if (isNaN(val) || val < 1) val = 1;
    setQuantity(modal, val);
  });

  // ── Event: form field validation ──
  document.addEventListener('input', e => {
    const modal = e.target.closest('.corporate-modal[aria-hidden="false"]');
    if (!modal) return;
    if (e.target.matches('[name="properties[purpose]"], [name="properties[company_name]"], [name="properties[company_email]"]')) {
      checkFormValidity(modal);
    }
  });

  // ── Event: form submit → cart ──
  document.addEventListener('submit', e => {
    if (!e.target.matches('.corporate-modal[aria-hidden="false"] .add-to-cart-form2')) return;
    e.preventDefault();
    const form = e.target;
    const modal = form.closest('.corporate-modal');
    if (modal.dataset.variantAvailable === 'false') return;

    const purpose = form.querySelector('[name="properties[purpose]"]');
    const company = form.querySelector('[name="properties[company_name]"]');
    const email = form.querySelector('[name="properties[company_email]"]');
    if (!purpose.value || !company.value || !email.value) return;

    clearQtyError(modal);

    if (window.ShopifyAPI?.addItemFromForm2) {
      ShopifyAPI.addItemFromForm2(form, null, xhr => {
        try {
          const data = JSON.parse(xhr.responseText);
          if (data.description) {
            const div = document.createElement('div');
            div.className = 'errors qty-error';
            div.textContent = data.description;
            form.after(div);
          }
        } catch { }
      });
    }
  });

  // form number quantity
  const qtyInputs = document.querySelectorAll('[data-qty-input]');

  qtyInputs.forEach((qtyInput) => {
    qtyInput.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value > 50) {
        value = 50;
      }

      if (value < 1 && value !== '') {
        value = 1;
      }
      e.target.value = value;
    });
  });

});